// src/components/widgets/GlobalWidgets.tsx
import { useEffect } from "react";

declare global {
  interface Window {
    HelpCrunch: any;
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

const GlobalWidgets: React.FC = () => {
  useEffect(() => {
    // HelpCrunch
    if (
      !document.querySelector(
        'script[src="https://embed.helpcrunch.com/sdk.js"]'
      )
    ) {
      window.helpcrunchSettings = {
        organization: "meteam",
        appId: "f61ce0c4-7896-42ec-90dc-6b93d6d971f8",
      };

      const hcScript = document.createElement("script");
      hcScript.src = "https://embed.helpcrunch.com/sdk.js";
      hcScript.async = true;
      document.body.appendChild(hcScript);

      if (!window.HelpCrunch) {
        window.HelpCrunch = function (...args: unknown[]) {
          (window.HelpCrunch.q = window.HelpCrunch.q || []).push(args);
        };
        window.HelpCrunch.q = window.HelpCrunch.q || [];
      }
    }

    // Google Analytics
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    function gtag(...args: any[]) {
      window.dataLayer!.push(args);
    }

    window.gtag = window.gtag || gtag;

    if (
      !document.querySelector(
        'script[src="https://www.googletagmanager.com/gtag/js?id=G-S6N305B38X"]'
      )
    ) {
      const gaScript = document.createElement("script");
      gaScript.async = true;
      gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-S6N305B38X";
      document.head.appendChild(gaScript);

      window.gtag("js", new Date());
      window.gtag("config", "G-S6N305B38X", {
        send_page_view: true,
      });
    }
  }, []);

  return null;
};

export default GlobalWidgets;
